import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Link,
  List,
  BlockQuote,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";

interface PennRichTextProps {
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
}

/** Controlled CKEditor 5 (ClassicEditor) wrapper. Emits HTML on change. */
export const PennRichText = ({ value, onChange, disabled, error, placeholder }: PennRichTextProps) => (
  <div className={`penn-rich-text rounded-lg border ${error ? "border-red-400" : "border-gray-300 dark:border-gray-700"} ${disabled ? "opacity-70" : ""}`}>
    <CKEditor
      editor={ClassicEditor}
      data={value ?? ""}
      disabled={disabled}
      config={{
        licenseKey: "GPL",
        placeholder,
        plugins: [Essentials, Paragraph, Heading, Bold, Italic, Underline, Link, List, BlockQuote],
        toolbar: [
          "heading", "|",
          "bold", "italic", "underline", "link", "|",
          "bulletedList", "numberedList", "blockQuote", "|",
          "undo", "redo",
        ],
      }}
      onChange={(_evt, editor) => onChange(editor.getData())}
    />
  </div>
);
